<template>
<body style="font-size: 18px;">
  <div class="dataUpload">
    <div class="upload-contacts_info">
      <div class="upload-contacts_info_line">
        <div class="contacts-info-top">
          <div class="contacts-info-name">
            <em>姓名:</em>
            <em>{{data_param.name}}</em>
          </div>
          <div class="contacts-info-type">
            <em>所属类型:</em>
            <em>{{data_param.type_name}}</em>
          </div>
        </div>
      </div>

      <div class="date-name-title">
        <h1 class="date-name">资料名称</h1>
        <h1 class="date-pass">是否合格</h1>
      </div>
      <div
        class="upload-contacts_info_line"
        v-for="(atta, index) in atta_list"
        v-if="getDetailValue(atta.table_name, 'status') != ''"
      >
        <div class="upload-contacts_info_input">
          <div>
            <div class="data-name-item">
              <p class="name">
                <a
                  :href="url_info[atta.attachment_info_id]"
                  class="url_a"
                  target="_blank"
                  v-if="url_info['type_'+atta.attachment_info_id] == 'doc'"
                >{{getDataName(atta.table_name)}}</a>
                <a
                  @click="previewImg(url_info[atta.attachment_info_id], atta.table_name)"
                  class="url_a"
                  v-else
                >{{getDataName(atta.table_name)}}</a>
              </p>
              <div class="right">
                <span
                  :class="getDetailClass(getDetailValue(atta.table_name, 'status'))"
                  :title="getDetailValue(atta.table_name, 'remark')"
                  @click="showRemark(getDetailValue(atta.table_name, 'remark'))"
                >{{getDetailValue(atta.table_name, 'status') | getTranslate}}</span>
                <input
                  @click="pushToUpload"
                  type="button"
                  v-if="$isLogin(1) && getDetailValue(atta.table_name, 'status') == 0 "
                  value="重新上传"
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="upload-contacts_info_line">
          <div class="submit-btn">
            <input type="button"
                   name="back"
                   @click="$pushByName($isLogin(1) ? 'customerOrderDetail' : 'agentOrderDetail',{order_id:data_param.order_id})"
                   value="返回" />
          </div>
      </div>-->
    </div>
    <popup-img-dialog
      :previewInfo="previewInfo"
      @closeDialog="close"
      v-show="previewInfo.showDialog"
    ></popup-img-dialog>
    <mt-popup class="custom-popup" v-model="is_popup">{{show_remark}}</mt-popup>
  </div>
</body>
</template>

<script>
import { ImgDialog } from '@/components/imgDialog'
import { PopupImgDialog } from '@/components/imgDialog'
export default {
  name: 'DataReview',
  components: { ImgDialog, PopupImgDialog },
  data () {
    return {
      data_param: {
        name_list_info_id: 0,
        order_id: 0,
        plan_id: 0,
        name: '',
        type: '',
        type_name: '',
      },
      atta_list: [],
      visa_data: [],
      url_info: {},
      sc_list: [],
      previewInfo: {
        title: '',
        url: '',
        showDialog: false
      },
      is_popup: false,
      show_remark: ''
    }
  },
  props: {
    params: Object
  },
  created () {
    this.data_param.name_list_info_id = this.params.name_list_info_id
    this.data_param.order_id = this.params.order_id
    this.data_param.name = this.params.name
    this.data_param.plan_id = this.params.plan_id
    this.data_param.type = this.params.type
    this.data_param.type_name = this.params.type_name
    this.initData();
  },
  filters: {
    getTranslate (state) {
      var res = ''
      if (state == '0') {
        res = '否'
      } else if (state == '1') {
        res = '是'
      } else {
        res = '未审核'
      }
      return res
    }
  },
  methods: {
    showRemark (val) {
      if (val) {
        this.is_popup = true
        this.show_remark = val
      }

    },
    initData () {
      this.$myGet('order_route/data/' + this.data_param.plan_id + '/'
        + this.data_param.name_list_info_id + '/' + this.data_param.order_id + '/' + this.data_param.type)
        .then(res => {
          const rcode = res.response.data.rcode
          this.atta_list = res.response.data.atta_list
          this.visa_data = res.response.data.data_detail
          this.url_info = res.response.data.atta_url_info
          this.sc_list = res.response.data.sc_list
        })
        .catch(err => {
          this.$msg('[' + err.status + ']' + err.message, 'err', 3000)
        })
    },
    getDetail (type) {
      type = this.$util.subStr(type, 'new_name_list_info_')
      for (var index in this.visa_data) {
        var detail = this.visa_data[index]
        //console.log(type + '][' + index + '][' + detail + '][' + detail.id);
        if (type == detail.id) {
          return detail
        }
      }
    },
    getDetailClass (state) {
      var res = ''
      if (state == '0') {
        res = 'not-pass'
      } else if (state == '1') {
        res = 'pass'
      } else {
        res = 'to-audit'
      }
      return res
    },
    getDetailValue (type, val) {
      var detail = this.getDetail(type)
      var value = ''
      if (detail) {
        value = detail[val]
      }
      return value
    },
    getDataName (type) { // 获取签证资料名称
      type = this.$util.subStr(type, 'new_name_list_info_')
      for (var index in this.sc_list) {
        var id = this.sc_list[index].system_config.system_config_id
        if (type == id) {
          return this.sc_list[index].system_config.key_name
        }
      }
      return ''
    },
    // 跳转到重新上传页面
    pushToUpload () {
      // this.$pushByName('dataUpload', this.data_param)
      this.$domUtils.dispatch(this, 'DataParent', 'cut.data', this.data_param)
    },
    getUrl (attaId) {
      return this.url_info[attaId]
    },
    // 预览图片
    previewImg (url, title) {
      this.previewInfo.url = url
      this.previewInfo.title = title
      this.previewInfo.showDialog = true
    },
    close () {
      this.previewInfo.showDialog = false;
    }
  },
}
</script>

<style lang="" scoped>
@import '../../../assets/css/pages/customer/css.css';
.url_a {
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/pages/customer/p_center/dataReview.vue